import { getCountries } from 'react-phone-number-input';

import type { CountryCode } from 'libphonenumber-js';

const DEFAULT_COUNTRY_CODES: CountryCode[] = ['US', 'CA', 'IL'];

export const CCountryCodes: CountryCode[] = getCountries().filter(
  (code): code is CountryCode =>
    DEFAULT_COUNTRY_CODES.length
      ? DEFAULT_COUNTRY_CODES.includes(code as CountryCode)
      : Boolean(code),
);
